export const SESSION_MY_HOME_TOOLTIP_KEY = 'my_home_tooltip_key';
export enum EMyHomeFrom {
  fromHeader = '?from=header',
  fromMain = '?from=main_menu',
}
